(function () {
  var splash = document.getElementById('locane-splash');
  if (!splash) return;

  var SESSION_KEY = 'locaneSplashShown';
  if (sessionStorage.getItem(SESSION_KEY)) {
    splash.remove();
    return;
  }

  var minDuration = parseInt(splash.dataset.minDuration, 10) || 900;
  var failSafeMs = 2000;
  var start = Date.now();
  var hidden = false;

  function hide() {
    if (hidden) return;
    hidden = true;
    sessionStorage.setItem(SESSION_KEY, '1');
    splash.classList.add('locane-splash--hidden');
    splash.addEventListener('transitionend', function () {
      splash.remove();
    }, { once: true });
  }

  function ready() {
    var elapsed = Date.now() - start;
    var wait = Math.max(minDuration - elapsed, 0);
    setTimeout(hide, wait);
  }

  if (document.readyState === 'complete') {
    ready();
  } else {
    window.addEventListener('load', ready, { once: true });
  }

  // Fail-safe: never block the page for longer than this, no matter what.
  setTimeout(hide, failSafeMs);
})();
